import { InlineBanner } from '@cad-arc';
import { useAdditionalInfos } from '../../hooks/use-additional-infos/additional-infos-provider';
import React from 'react';

export const InlineBanners = (): React.JSX.Element => {
    const { isFetchingNextPage, pageFetchFailed, retryPageFetch } = useAdditionalInfos();

    return pageFetchFailed ? (
        <InlineBanner
            actions={[
                {
                    children: 'Retry',
                    onClick: retryPageFetch,
                    isLoading: isFetchingNextPage,
                },
            ]}
            description="Try again later or contact IT for support."
            status="attention"
            title="Unable to load historical narrative entries"
        />
    ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <></>
    );
};
